import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';
import messages from '../../../configurations/messages';

class d extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            isDelete: false,
            touchedForm:false,
            settingsConfig:  props.isNew ? {} : props.settingsConfig,
            codeValidity: -1,
            typeValidity:-1,
            enabledValidity: -1,
            descriptionValidity: -1,
            settingsValueValidity: -1,
            extraInfoValidity: -1,
            settingsTypes: [],
            title: props.isNew ? "New Settings Configuration" : `Settings Configuration`,
            updating: false,

        };

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "100px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onSelectInputChange = this.onSelectInputChange.bind(this);
    }

    onTextInputChange(evt) {
        let settingsConfig = Object.assign({}, this.state.settingsConfig);
        settingsConfig[evt.target.id] = evt.target.value || null;
    
        let stateUpdate = {
          settingsConfig,
          touchedForm: true
        };
        stateUpdate[`${evt.target.id}Validity`] = evt ? 1 : 0;
    
        this.setState(stateUpdate);
      }


    onSelectInputChange(evt, id) {
        let value = null;
        if(evt && evt.label) value = evt.value;

        let settingsConfig = Object.assign({}, this.state.settingsConfig);
        settingsConfig[id] = evt ? value : null;

        this.setState({
            settingsConfig,
            [id]: evt,
            touchedForm: true,
            [`${id}Validity`]: evt ? 1 : 0
        });
    }


    componentDidMount() {

        //Get Setting Types
        ArbiterApi.getSettingsConfigTypes()
            .then(response => {

                let settingsTypes = response.data.map(settingType => {
                    return { label: settingType, value: settingType };
                  });
          
                  this.setState({ settingsTypes });
            })
            .catch(error => {
                Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_SETTINGS_CONFIG_TYPES}`, '']);
            })
    }

    handleAction(evt) {
        this.setState({ updating: true });
        const {settingsConfig, isNew} = this.state

        let promise = this.state.isNew ? ArbiterApi.createSettingsConfig(settingsConfig) : ArbiterApi.updateSettingsConfig(settingsConfig.id, settingsConfig)
        promise.then((response) => {
            Toaster.success(`${isNew ? messages.SUCCESS_SETTINGS_CONFIG_CREATED : messages.SUCCESS_SETTINGS_CONFIG_UPDATED}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                Util.errorMessageToast(Toaster,error.data,[`${error.data ? error.data.description : error.statusText}`,`${Messages.ERROR_SETTINGS_CONFIG_UPDATE} `]);
                this.setState({ updating: false });
            })
    }

    handleDeleteAction(evt) {
        this.setState({ updating: true });
        const settingsConfig = this.state.settingsConfig;
        ArbiterApi.deleteMerchantDisputant(settingsConfig.id)
            .then((response) => {
                Toaster.success(Messages.SUCCESS_SETTINGS_CONFIG_DELETED);
                this.setState({ updating: false });
                this.props.onRequestClose(evt, true);
            })
            .catch((error) => {
                error.data={description: "no response"}
                Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_SETTINGS_CONFIG_DELETE}`, '']);
                this.setState({ updating: false });
            });
    }


    render() {

        const {isNew, isView, isDelete} = this.state;
      
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Type:</label>
                                        <label>{this.state.settingsConfig.type}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Code:</label>
                                        <label>{this.state.settingsConfig.code}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Description:</label>
                                        <label>{this.state.settingsConfig.description}</label>
                                    </div>

                                    <div className="form-div">
                                        <label>Setting Value :</label>
                                        <label>{this.state.settingsConfig.settingsValue}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Extra Info:</label>
                                        <label>{this.state.settingsConfig.extraInfo}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Enabled:</label>
                                        <label>{`${this.state.settingsConfig.enabled ? "Yes" : "No"}`}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label className="required">Type</label>
                                        <Select
                                            id="type"
                                            value={this.state.settingsConfig.type}
                                            options={this.state.settingsTypes}
                                            onChange={evt=>this.onSelectInputChange(evt, 'type')}
                                            placeholder="Select Type"
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label className="required">Code</label>
                                        <FloatInput
                                            id="code"
                                            value={this.state.settingsConfig.code}
                                            onChange={this.onTextInputChange}
                                            placeholder="Code"
                                            maxLength="50"
                                            showError={this.state.codeValidity === 0}
                                            errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label className="required">Description</label>
                                        <FloatInput
                                            id="description"
                                            value={this.state.settingsConfig.description}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Description"
                                            maxLength="2555"
                                            showError={this.state.descriptionValidity === 0} 
                                            errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label className="required">Setting Value</label>
                                        <FloatInput
                                            id="settingsValue"
                                            value={this.state.settingsConfig.settingsValue}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Setting Value"
                                            maxLength="5"
                                            showError={this.state.settingsValueValidity === 0} 
                                            errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label>Extra Info</label>
                                        <FloatInput
                                            id="extraInfo"
                                            value={this.state.settingsConfig.extraInfo}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Extra Info"
                                            maxLength="5"
                                            errorMessage={`${Messages.INVALID_CODE}`}
                                        />
                                    </div>
                                    
                                    <div className="form-div">
                                        <label className="required">Enabled</label>
                                        <Select
                                            id="enabled"
                                            value={this.state.settingsConfig.enabled}
                                            options={ [{label: "Yes", value:true}, {label:'No', value:false}]}
                                            onChange={evt=>this.onSelectInputChange(evt, 'enabled')}
                                            placeholder="Select Enabled"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isDelete &&
                    <div className="mod-footer">

                        <div className="mod-footer-buttons">
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isView: false }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.UPDATE_SETTINGS_CONFIG]}>EDIT</CButton>
                            }
                            {isView &&
                                <CButton
                                    onClick={(evt) => { this.setState({ isDelete: true }) }}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.CREATE_SETTINGS_CONFIG]}>DELETE</CButton> 

                            }

                            {!isView && isNew &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.CREATE_SETTINGS_CONFIG]}>CREATE</CButton> 

                            }
                            {!isView && !isNew &&
                                <CButton
                                    onClick={(evt) => { this.handleAction(evt); }}
                                    disabled={this.state.updating || !this.formValid()}
                                    className="btn btn-primary"
                                    allowedPermissions={[Permissions.UPDATE_SETTINGS_CONFIG]}>UPDATE</CButton>

                            }

                            <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>

                        </div>
                    </div>
                }
                {isDelete &&
                    <div className="mod-footer">
                        <div className="action-warning">
                            {Messages.ACTION_WARNING}  ?
                                </div>
                        <div className="mod-footer-buttons">
                            <button onClick={(evt) => { this.setState({ isDelete: false }) }} disabled={this.state.updating} className="btn btn-danger">NO</button>
                            <button onClick={(evt) => { this.handleDeleteAction(evt) }} disabled={this.state.updating} className="btn btn-primary">YES</button>

                        </div>
                    </div>
                }
            </Modal>
        )
    }

    formValid() {
        const {touchedForm, settingsValueValidity, typeValidity, descriptionValidity, enabledValidity,codeValidity} = this.state
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
           return touchedForm && codeValidity === 1 &&
            typeValidity === 1  &&
            enabledValidity  === 1 &&
            descriptionValidity  === 1 &&
            settingsValueValidity  === 1
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return touchedForm && codeValidity && typeValidity && enabledValidity && descriptionValidity && settingsValueValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(d, [Permissions.VIEW_SETTINGS_CONFIG]));


// WEBPACK FOOTER //
// ./src/components/admin/settingsConfig/settingsConfigModal.js